import React from "react";
import { Container, SectionLabel } from "@/components/shared";
import { Flag, Target, Users } from "lucide-react";
import { Brand } from "@/components/Brand";

export default function About() {
  return (
    <div>
      <section className="border-b border-ff-border bg-ff-blue text-white">
        <Container className="py-16 lg:py-20">
          <SectionLabel><span className="text-white/60">About <Brand /></span></SectionLabel>
          <h1 className="mt-3 max-w-3xl font-heading text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">
            A crowdfunding platform built on trust, made in the USA
          </h1>
          <p className="mt-5 max-w-2xl text-white/70">
            FightFund exists to make giving fast for donors while holding fundraisers to a strict, honest
            standard. We're USA based, managed by U.S. citizens, and available only in the United States.
          </p>
        </Container>
      </section>

      <section className="bg-white">
        <Container className="grid gap-6 py-16 md:grid-cols-3">
          {[
            { icon: Target, t: "Our mission", d: "Give donors confidence and give fundraisers a fair, accountable path to the funds they need." },
            { icon: Users, t: "Who we serve", d: "Individuals, communities, and U.S. nonprofits raising money for the causes that matter most." },
            { icon: Flag, t: "Where we operate", d: "U.S.-only. USD-only. U.S. payout accounts and U.S. nonprofits at launch. Web first, mobile soon." },
          ].map((v) => (
            <div key={v.t} className="rounded-xl border border-ff-border bg-white p-8 shadow-sm">
              <span className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-ff-red">
                <v.icon className="h-6 w-6 text-white" />
              </span>
              <h3 className="font-heading text-lg font-bold text-ff-blue">{v.t}</h3>
              <p className="mt-2 text-sm text-ff-dark">{v.d}</p>
            </div>
          ))}
        </Container>
      </section>

      <section className="bg-[#F3F4F6]">
        <Container className="py-16">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="font-heading text-2xl font-bold text-ff-blue sm:text-3xl">Our promise</h2>
            <p className="mt-4 text-ff-dark">
              We will always be honest about what we've reviewed. We won't claim to be “fraud-proof” or
              “guaranteed safe.” Instead, we review campaigns and payout requests before funds are released,
              and we tell you exactly where every campaign stands.
            </p>
          </div>
        </Container>
      </section>
    </div>
  );
}
